import { Box } from '@mui/material';
import ChartSection from '../shared/ChartSection';
import DualAxisLine from '../shared/DualAxisLine';
import useNivoTheme from '../shared/useNivoTheme';

export default function VolumeVsFedRate({ data }) {
    const { colors } = useNivoTheme();
    if (!data || data.length === 0) return null;

    const tickValues = data.filter((_, i) => i % 12 === 0).map(d => d.month);

    return (
        <ChartSection
            id="volume-fed"
            title="Does Congress trade more when interest rates change?"
            subtitle="Monthly congressional trade volume overlaid with the Federal Funds Rate"
        >
            <Box sx={{ height: 380 }}>
                <DualAxisLine
                    primary={{
                        id: 'Trade Volume',
                        color: colors.primary,
                        unit: '',
                        data: data.map(d => ({ x: d.month, y: d.trades })),
                    }}
                    secondary={{
                        id: 'Fed Funds Rate',
                        color: colors.error,
                        unit: '%',
                        data: data.map(d => ({ x: d.month, y: d.fed_rate })),
                    }}
                    leftLegend="Trades"
                    rightLegend="Fed Funds Rate (%)"
                    tickValues={tickValues}
                />
            </Box>
        </ChartSection>
    );
}
